export const API_GET_ALL_PATIENT = "API_GET_ALL_PATIENT";
export const API_GET_ALL_PATIENT_SUCCESS = "API_GET_ALL_PATIENT_SUCCESS";
export const API_GET_ALL_PATIENT_FAIL = "API_GET_ALL_PATIENT_FAIL";

export const API_SEARCH_PATIENT = "API_SEARCH_PATIENT";
export const API_SEARCH_PATIENT_SUCCESS = "API_SEARCH_PATIENT_SUCCESS";
export const API_SEARCH_PATIENT_FAIL = "API_SEARCH_PATIENT_FAIL";

export const API_POST_PATIENT = "API_POST_PATIENT";
export const API_POST_PATIENT_SUCCESS = "API_POST_PATIENT_SUCCESS";
export const API_POST_PATIENT_FAIL = "API_POST_PATIENT_FAIL";

export const API_PATCH_PATIENT = "API_PATCH_PATIENT";
export const API_PATCH_PATIENT_SUCCESS = "API_PATCH_PATIENT_SUCCESS";
export const API_PATCH_PATIENT_FAIL = "API_PATCH_PATIENT_FAIL";

export const API_PATCH_PATIENT_FOLDERMANAGER = "API_PATCH_PATIENT_FOLDERMANAGER";
export const API_PATCH_PATIENT_FOLDERMANAGER_SUCCESS = "API_PATCH_PATIENT_FOLDERMANAGER_SUCCESS";
export const API_PATCH_PATIENT_FOLDERMANAGER_FAIL = "API_PATCH_PATIENT_FOLDERMANAGER_FAIL";

export const API_DELETE_PATIENT = "API_DELETE_PATIENT";
export const API_DELETE_PATIENT_SUCCESS = "API_DELETE_PATIENT_SUCCESS";
export const API_DELETE_PATIENT_FAIL = "API_DELETE_PATIENT_FAIL";

export const API_GET_FOLDERS_PATIENT = "API_GET_FOLDERS_PATIENT";
export const API_GET_FOLDERS_PATIENT_SUCCESS = "API_GET_FOLDERS_PATIENT_SUCCESS";
export const API_GET_FOLDERS_PATIENT_FAIL = "API_GET_FOLDERS_PATIENT_FAIL";

export const API_GET_PATIENT = "API_GET_PATIENT";
export const API_GET_PATIENT_SUCCESS = "API_GET_PATIENT_SUCCESS";
export const API_GET_PATIENT_FAIL = "API_GET_PATIENT_FAIL";

export const API_GET_PATIENT_EXISTS = "API_GET_PATIENT_EXISTS";
export const API_GET_PATIENT_EXISTS_SUCCESS = "API_GET_PATIENT_EXISTS_SUCCESS";
export const API_GET_PATIENT_EXISTS_FAIL = "API_GET_PATIENT_EXISTS_FAIL";

export const API_POST_DSP_AGREEMENT = "API_POST_DSP_AGREEMENT";
export const API_POST_DSP_AGREEMENT_SUCCESS = "API_POST_DSP_AGREEMENT_SUCCESS";
export const API_POST_DSP_AGREEMENT_FAIL = "API_POST_DSP_AGREEMENT_FAIL";

export const API_GET_MATCHING_PATIENT = "API_GET_MATCHING_PATIENT";
export const API_GET_MATCHING_PATIENT_SUCCESS = "API_GET_MATCHING_PATIENT_SUCCESS";
export const API_GET_MATCHING_PATIENT_FAIL = "API_GET_MATCHING_PATIENT_FAIL";

export const API_GET_MPI_PATIENT_BY_MATRICULE = "API_GET_MPI_PATIENT_BY_MATRICULE";
export const API_GET_MPI_PATIENT_BY_MATRICULE_SUCCESS = "API_GET_MPI_PATIENT_BY_MATRICULE_SUCCESS";
export const API_GET_MPI_PATIENT_BY_MATRICULE_FAIL = "API_GET_MPI_PATIENT_BY_MATRICULE_FAIL";

export const API_POST_PATIENT_DOCUMENT = "API_POST_PATIENT_DOCUMENT";
export const API_POST_PATIENT_DOCUMENT_SUCCESS = "API_POST_PATIENT_DOCUMENT_SUCCESS";
export const API_POST_PATIENT_DOCUMENT_FAIL = "API_POST_PATIENT_DOCUMENT_FAIL";

export const API_DELETE_PATIENT_DOCUMENT = "API_DELETE_PATIENT_DOCUMENT";
export const API_DELETE_PATIENT_DOCUMENT_SUCCESS = "API_DELETE_PATIENT_DOCUMENT_SUCCESS";
export const API_DELETE_PATIENT_DOCUMENT_FAIL = "API_DELETE_PATIENT_DOCUMENT_FAIL";

export const API_GET_PATIENT_DOCUMENT = "API_GET_PATIENT_DOCUMENT";
export const API_GET_PATIENT_DOCUMENT_SUCCESS = "API_GET_PATIENT_DOCUMENT_SUCCESS";
export const API_GET_PATIENT_DOCUMENT_FAIL = "API_GET_PATIENT_DOCUMENT_FAIL";

export const API_GET_PATIENT_IATA_QRCODE = "API_GET_PATIENT_IATA_QRCODE";
export const API_GET_PATIENT_IATA_QRCODE_SUCCESS = "API_GET_PATIENT_IATA_QRCODE_SUCCESS";

export const API_GET_PATIENT_IATA_DID = "API_GET_PATIENT_IATA_DID";
export const API_GET_PATIENT_IATA_DID_SUCCESS = "API_GET_PATIENT_IATA_DID_SUCCESS";

export const API_CLEAR_PATIENT_IATA = "API_CLEAR_PATIENT_IATA";
export const API_GET_PATIENT_MYLAB = "API_GET_PATIENT_MYLAB";

export const API_GET_PATIENT_INVOICES = "API_GET_PATIENT_INVOICES";
export const API_GET_PATIENT_INVOICES_SUCCESS = "API_GET_PATIENT_INVOICES_SUCCESS";
export const API_GET_PATIENT_INVOICES_FAIL = "API_GET_PATIENT_INVOICES_FAIL";

export const API_GET_PATIENT_DKV_STATUS = "API_GET_PATIENT_DKV_STATUS";
export const API_GET_PATIENT_DKV_STATUS_SUCCESS = "API_GET_PATIENT_DKV_STATUS_SUCCESS";
export const API_GET_PATIENT_DKV_STATUS_FAIL = "API_GET_PATIENT_DKV_STATUS_FAIL";

export const API_CLEAN_PATIENT_DKV_STATUS = "API_CLEAN_PATIENT_DKV_STATUS";

export const API_GET_PATIENT_CASING_PAYMENTS = "API_GET_PATIENT_CASING_PAYMENTS";
export const API_GET_PATIENT_CASING_PAYMENTS_SUCCESS = "API_GET_PATIENT_CASING_PAYMENTS_SUCCESS";
export const API_GET_PATIENT_CASING_PAYMENTS_FAIL = "API_GET_PATIENT_CASING_PAYMENTS_FAIL";

export const API_PUT_PATIENT_CASING_PAYMENTS = "API_PUT_PATIENT_CASING_PAYMENTS";
export const API_PUT_PATIENT_CASING_PAYMENTS_SUCCESS = "API_PUT_PATIENT_CASING_PAYMENTS_SUCCESS";
export const API_PUT_PATIENT_CASING_PAYMENTS_FAIL = "API_PUT_PATIENT_CASING_PAYMENTS_FAIL";

export const API_DELETE_PATIENT_CASING_PAYMENTS = "API_DELETE_PATIENT_CASING_PAYMENTS";
export const API_DELETE_PATIENT_CASING_PAYMENTS_SUCCESS = "API_DELETE_PATIENT_CASING_PAYMENTS_SUCCESS";
export const API_DELETE_PATIENT_CASING_PAYMENTS_FAIL = "API_DELETE_PATIENT_CASING_PAYMENTS_FAIL";

export const RESET_INVOICES_FOR_PATIENT = "RESET_INVOICES_FOR_PATIENT";
